import type { TopicExercises } from "~/features/computer/data/exercises/exercise.types";

export const algorithmExercises: TopicExercises = {
  mcqs: [
    {
      id: "alg1",
      difficulty: "easy",
      question: "Well-defined problem kya hota hai?",
      options: [
        "Unclear requirements",
        "Vague inputs",
        "Clear inputs, process aur output",
        "Undefined solution",
      ],
      correctIndex: 2,
      explanation: "Well-defined problem me sab kuch clear hota hai - input, process aur output",
    },
    {
      id: "alg2",
      difficulty: "easy",
      question: "Algorithm ka main purpose kya hai?",
      options: [
        "Random solution dena",
        "Step-by-step problem solve karna",
        "Code likhna",
        "Data store karna",
      ],
      correctIndex: 1,
      explanation: "Algorithm ka matlab hi steps me problem solve karna hai",
    },
    {
      id: "alg3",
      difficulty: "easy",
      question: "Generate and test method kya karta hai?",
      options: [
        "Ek hi solution deta hai",
        "Different solutions try karta hai",
        "Data delete karta hai",
        "Output skip karta hai",
      ],
      correctIndex: 1,
      explanation: "Is method me multiple attempts try kiye jate hain jab tak solution mil na jaye",
    },
    {
      id: "alg4",
      difficulty: "medium",
      question: "Fast algorithm ka matlab kya hai?",
      options: [
        "Zyada memory use kare",
        "Kam steps me result de",
        "Complex code ho",
        "Zyada loops ho",
      ],
      correctIndex: 1,
      explanation: "Fast algorithm wo hota hai jo kam time me result de",
    },
    {
      id: "alg5",
      difficulty: "medium",
      question: "Bubble sort me kya hota hai?",
      options: [
        "Random sorting",
        "Adjacent values compare aur swap",
        "Data delete hota hai",
        "Sirf ek baar run hota hai",
      ],
      correctIndex: 1,
      explanation: "Bubble sort me side-by-side values compare hoti hain aur swap hota hai",
    },
    {
      id: "alg6",
      difficulty: "medium",
      question: "Linear search kaise kaam karta hai?",
      options: [
        "Direct result deta hai",
        "Ek ek element check karta hai",
        "Random access karta hai",
        "Data sort karta hai",
      ],
      correctIndex: 1,
      explanation: "Linear search me har element sequentially check hota hai",
    },
    {
      id: "alg7",
      difficulty: "hard",
      question: "Time complexity ka concept kya batata hai?",
      options: [
        "Memory usage",
        "Time vs input size relation",
        "Code length",
        "Loop count",
      ],
      correctIndex: 1,
      explanation: "Time complexity batata hai ke input size badhne par time kaise change hota hai",
    },
    {
      id: "alg8",
      difficulty: "hard",
      question: "Ek efficient algorithm kya karega?",
      options: [
        "Zyada steps lega",
        "Kam steps me solution dega",
        "Memory waste karega",
        "Random output dega",
      ],
      correctIndex: 1,
      explanation: "Efficient algorithm kam time aur kam steps use karta hai",
    },
  ],
  short: [
    {
      id: "alg-short-1",
      question: "Well-defined aur ill-defined problem mein farq kya hota hai?",
      answer: "Well-defined problem mein input, output aur goal clear hota hai. Ill-defined problem mein requirements vague hoti hain aur path clear nahi hota.",
    },
    {
      id: "alg-short-2",
      question: "Problem solving ke basic steps kya hote hain?",
      answer: "Pehle problem samjho, phir input aur output identify karo, phir process ko chhote steps mein todo, aur akhir mein result check karo.",
    },
    {
      id: "alg-short-3",
      question: "Algorithm fast ya slow kaise decide karte hain?",
      answer: "Simple level par dekhte hain ke kaam complete karne ke liye kitne steps ya operations lag rahe hain. Kam steps hon to algorithm zyada efficient samjha jata hai.",
    },
  ],
  long: [
    {
      id: "alg-long-1",
      question: "Bubble sort ko simple steps mein explain karo.",
      solution: "Bubble sort mein paas paas numbers compare kiye jate hain. Agar order galat ho to swap hota hai. Yeh process repeat hota hai jab tak list theek order mein na aa jaye.",
      steps: [
        "Adjacent numbers compare karo.",
        "Agar left number bara ho to swap karo.",
        "Aik pass mein sab adjacent pairs ko check karo.",
        "Yeh process repeat karo jab tak list sorted na ho jaye.",
      ],
      code: "numbers = [5, 3, 4]\nfor _ in range(len(numbers)):\n    for i in range(len(numbers) - 1):\n        if numbers[i] > numbers[i + 1]:\n            numbers[i], numbers[i + 1] = numbers[i + 1], numbers[i]",
    },
  ],
};
